module.exports = __webpack_public_path__ + "media/newstyle/images/hand-intelligent-c22ebb9526a8248e0f218e7fca7fbd63.png";